import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { concatMap, delay, retryWhen } from 'rxjs/operators';

@Injectable()
export class RetryInterceptor implements HttpInterceptor {
  retryCount = 2;
  retryWaitMilliSeconds = 1000;

  // https://danielk.tech/home/angular-retry-an-http-request
  // retry the http request x times, except when it's an internal server error
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      retryWhen(error =>
        error.pipe(
          concatMap((error, count) => {
            if (count < this.retryCount && error.status !== 500) {
              return of(error); // retry
            }
            return throwError(error);
          }),
          delay(this.retryWaitMilliSeconds)
        )
      )
    );
  }
}
